import { React } from "react";
import { Card } from "antd";
import Slider from "react-slick";
import { Button } from "../../../components";
import { sliderSettings } from "../config";

const tabs = [
  {
    name: "All Forum",
    active: true
  },
  {
    name: "Soccer",
    active: false
  },
  {
    name: "Basketball",
    active: false
  },
  {
    name: "Tennis",
    active: false
  },
  {
    name: "Cricket",
    active: false
  },
  {
    name: "Tennis",
    active: true
  },
  {
    name: "Basketball",
    active: false
  },
  {
    name: "Tennis",
    active: false
  },
  {
    name: "Cricket",
    active: false
  },
  {
    name: "Tennis",
    active: true
  },
  {
    name: "Basketball",
    active: false
  },
];

const NavigationTabs = () => {
  return (
    <Card style={{padding: 20, borderRadius: 10}} className="no-border">
      <Slider {...sliderSettings}>
        <div></div>
        {tabs.map((item, index) => (
          <div key={index}>
            <Button
              type="primary"
              className={`mt-0 primary-color ${item.active ? "button-tetiary" : "button-transparent-tetiary"}`}
              title={item.name}
              style={{
                height: "50px",
                borderRadius: "30px",
                paddingLeft: "2.5em",
                paddingRight: "2.5em",
              }}
            />
          </div>
        ))}
      </Slider>
    </Card>
  );
};

export default NavigationTabs;